import { useMemo } from "react";
import { useTranslation } from "react-i18next";
const k = {
    errorMessage: "core.components.module-access-error.module-access-error-i18n.errorMessage"
};
export const translations = {
    da: {
        errorMessage: "Du har ikke adgang til modulet."
    },
    en: {
        errorMessage: "You do not have access to this module."
    }
};
export const useT = () => {
    const { t, i18n } = useTranslation();
    const localT = useMemo(() => ({
        errorMessage: t(k.errorMessage)
    }), [i18n.language]);
    return useMemo(() => ({ t: localT, i18n }), [localT, i18n]);
};
